import { WeekDays } from '../enums/weekdays.enum';

export const WeekDayNumbers = Object.values(WeekDays).filter((key) => typeof key === 'number');
